var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"1.0.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  
  // Environment and release tracking
  environment: process.env.NODE_ENV || 'development',
  release: process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0',
  
  // Performance monitoring
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  
  // Session tracking
  autoSessionTracking: true,
  
  // Error filtering
  beforeSend(event, hint) {
    // Filter out known non-critical errors
    const error = hint.originalException;
    
    if (error && typeof error.message === 'string') {
      // Filter out PostHog iframe communication errors
      if (error.message.includes('relay-message-to-frames') ||
          error.message.includes('posthog') ||
          error.message.includes('Non-Error promise rejection captured')) {
        return null;
      }
      
      // Filter out network errors that are expected
      if (error.message.includes('Failed to fetch') && 
          error.message.includes('chrome-extension://')) {
        return null;
      }
      
      // Filter out third-party script errors and browser extension errors
      if (error.message.includes('SCDynimacBridge') ||
          error.message.includes('Can\'t find variable: SC') ||
          error.message.includes('undefined is not an object (evaluating \'SC')) {
        return null;
      }
    }
    
    // Add additional context
    if (typeof window !== 'undefined') {
      event.extra = {
        ...event.extra,
        url: window.location.href,
        userAgent: window.navigator.userAgent,
        timestamp: new Date().toISOString(),
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
        screen: {
          width: window.screen.width,
          height: window.screen.height,
        },
      };
      
      // Add page-specific context
      const pathname = window.location.pathname;
      if (pathname.includes('/i/')) {
        event.tags = { ...event.tags, page_type: 'invite' };
        event.extra.invite_id = pathname.split('/').pop();
      } else if (pathname.includes('/e/')) {
        event.tags = { ...event.tags, page_type: 'preview' };
        event.extra.event_id = pathname.split('/').pop();
      } else if (pathname.includes('/p/')) {
        event.tags = { ...event.tags, page_type: 'public' };
        event.extra.event_id = pathname.split('/').pop();
      }
    }
    
    return event;
  },
  
  // Integration configuration
  integrations: [
    new Sentry.BrowserTracing({
      // Set sampling rate for performance monitoring
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/[^/]*\.invitd\.us/,
        /^https:\/\/api\.invitd\.us/,
      ],
    }),
  ],
  
  // Additional options
  enabled: process.env.NODE_ENV === 'production' || process.env.SENTRY_ENABLED === 'true',
  debug: process.env.NODE_ENV === 'development',
  
  // Privacy settings
  sendDefaultPii: false,
  
  // Error capture settings
  captureUnhandledRejections: true,
  maxBreadcrumbs: 50,
  
  // Transport options
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
});

